import React from 'react';
import { useField } from 'formik';
import './_textInput.scss';

interface TextInputType {
  id?: string;
  placeholder?: string;
  label?: string;
  helperText?: string;
  error: boolean;
  name: string;
  required?: boolean;
}

export const TextInputFormik = (props: TextInputType) => {
  const { id, placeholder, label, helperText, error, name, required } = props;

  const [field, meta] = useField(name);

  return (
    <>
      {label ? <label className="input-label">{label}</label> : ''}
      <input
        type="text"
        id={id}
        className={`input-text-box ${error ? 'error-border' : ''}`}
        placeholder={placeholder}
        {...field}
      />
      {helperText ? <p className="input-helper-label">{helperText}</p> : ''}

      {!meta.touched && !meta.error && helperText && (
        <div className="input-helper-label">{helperText}</div>
      )}

      {required && meta.touched && meta.error && (
        <div className="input-error-message">{meta.error}</div>
      )}
    </>
  );
};

export const TextInput = (props: TextInputType) => {
  const { id, placeholder, label, helperText, error } = props;
  return (
    <>
      {label ? <label className="input-label">{label}</label> : ''}
      <input
        type="text"
        id={id}
        className={`input-text-box ${error ? 'error-border' : ''}`}
        placeholder={placeholder}
      />
      {helperText ? <p className="input-helper-label">{helperText}</p> : ''}
    </>
  );
};
